export const salesAnalysisPeriodOptions = [2, 7, 14, 30, 90];
export const salesAnalysisAllTimeOptionValue = 7000;
